(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-product-truffle"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-gift-guide"] && !Shopify.designMode) return;
  try {
    
function initGiftGuides(scope) {
  scope.querySelectorAll('.tgg').forEach(guide => {
    if (guide.dataset.ready) return;
    guide.dataset.ready = 'true';
    const buttons = guide.querySelectorAll('[data-budget]');
    const cards = guide.querySelectorAll('[data-price]');
    buttons.forEach(button => button.addEventListener('click', () => {
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      let visible = 0;
      cards.forEach(card => {
        const price = Number(card.dataset.price);
        const budget = button.dataset.budget;
        const show = budget === 'all' || (budget === 'under20' && price < 2000) || (budget === 'under40' && price >= 2000 && price < 4000) || (budget === 'over40' && price >= 4000);
        card.hidden = !show;
        if (show) visible++;
      });
      guide.querySelector('.tgg-empty').hidden = visible > 0;
    }));
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initGiftGuides(document));
else initGiftGuides(document);
document.addEventListener('shopify:section:load', event => initGiftGuides(event.target));

  } catch(e) { console.error(e); }
})();
})();
